module.exports = __webpack_public_path__ + "media/src/img/facebook-icon-blue-0b9bd6bc8959482d53685336c931b046.svg";